import { ReactComponent as AppleIcon } from '../../../assets/icons/apple.svg';
import { ReactComponent as PlaystoreIcon } from '../../../assets/icons/playstore.svg';

export const downloadPoints = [
  {
    icon: <AppleIcon />,
    label: 'App Store',
  },
  {
    icon: <PlaystoreIcon />,
    label: 'Google Play',
  },
];
